import SidePanel from './sidepanel';

// Plain client-side filter for sidepanel lists (Payments Received, Pending
// Payments, Track Summaries/Questions sidebars, Email Mailings recipients
// picker). Nothing is ever saved -- the term resets whenever the sidepanel
// content reloads, same as before the clear button was added.
const SearchList = {
  start() {
    SidePanel.onUpdate(($sidepanel) => {
      $sidepanel.on('input', '[data-search-list]', this._handleSearch);
      $sidepanel.on('click', '.js-search-list-clear', this._handleClear);
      $sidepanel.find('[data-search-list]').each((_, input) => this._toggleClear($(input)));
    });
  },

  _toggleClear($input) {
    const $clear = $input.siblings('.js-search-list-clear');
    const $searchIcon = $input.siblings('.search__icon');
    const hasValue = !!$input.val();
    $clear.toggleClass('is-hidden', !hasValue);
    $searchIcon.toggleClass('is-hidden', hasValue);
  },

  _filter($input) {
    const itemSelector = $input.data('search-list');
    const searchTerm = $input.val().toLowerCase();
    if (searchTerm) {
      $(itemSelector).each((_, item) =>
        $(item).toggle($(item)
          .text()
          .toLowerCase()
          .indexOf(searchTerm) > -1));
    } else {
      $(itemSelector).show();
    }
  },

  _handleSearch(e) {
    const $input = $(e.currentTarget);
    SearchList._toggleClear($input);
    SearchList._filter($input);
  },

  _handleClear(e) {
    e.preventDefault();
    const $input = $(e.currentTarget).siblings('[data-search-list]');
    $input.val('').trigger('input').focus();
  }
};

export default SearchList;
